import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import OperatorFixedRouteView from "../components/OperatorViews/OperatorFixedRouteView";
import { AuthContext } from "./AuthContext";

const PrivateRoutes = () => {
  const { token, operatorView } = useContext(AuthContext);
  if (operatorView) {
    return <OperatorFixedRouteView />;
  }
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
